// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'

// ElementUI
import ElementUI from 'element-ui'
// ElementUI.Dialog.props.lockScroll.default = false;
Vue.use(ElementUI)
// 组件
import components from '@/components/index.js'
Vue.use(components)
// 样式
import '@/styles/index.js'
import '@/assets/iconfront/iconfont.css'
import '@/assets/iconfront/iconfont.js'

// filters验证方法
import * as filters from '@/utils/filters/index.js';
Vue.prototype.$filters = filters;
import { price } from '@/utils/filters/index.js';
Vue.filter('thousandthMoney', price);

//混入
import mixins from '@/common/mixin/index.js';
Vue.use(mixins);

Vue.config.productionTip = false

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
// console.log(process.env.NODE_ENV)



// WEBPACK FOOTER //
// ./src/main.js